export default __webpack_public_path__ + "static/media/Nickel.5acf0c84.png";